// import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  Stack,
  Typography,
  OutlinedInput,
  FormControl,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ApiService from "../../services/api-service";
import Loader from "../Loader";
import ConfirmPopup from "../ConfirmPopup";
import SikiInput from "../SikiInput";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import StreamShow from "./StreamShow";
import { useHistory, useParams } from "react-router-dom";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import React, { useState, useEffect } from "react";
import { copyToClipboard, getUserDetail } from "../../constants/function";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { ALLOWED_USER_ID, OBS_SERVER_URL } from "../../constants/api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function StreamingDetailPoup({
  open,
  handleClose,
  channelName,
}) {
  const { t } = useTranslation("common");
  const [title, setTitle] = React.useState("");
  const [goal, setGoal] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const [dirty, setDirty] = React.useState(false);
  const [oldGoal, setOldGoal] = React.useState({});
  const [old, setOld] = React.useState(false);
  const [openStream, setOpenStream] = React.useState(false);
  const history = useHistory();
  const [value, setValue] = useState("siki");
  const [copied, setCopied] = React.useState(null);
  const userData = getUserDetail();
  const [allowedUsers, setAllowedUsers] = React.useState([]);


  const getAddCount = async () => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_COUNT();
      setAllowedUsers(response["result"]["allowedUsers"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAddCount();
  }, []);

  const isUserIdPresent = allowedUsers.includes(userData["_id"]);

  const getGoal = async () => {
    try {
      setLoading(true);
      const goal = await ApiService.GOAL(channelName);
      if (goal.result && goal.result.length > 0) {
        setGoal(goal.result[0]?.totalGoalAmount);
        setTitle(goal.result[0]?.goalTitle);
        setDescription(goal.result[0]?.goalDescription);
        setShow(false);
        setOldGoal({ ...goal.result[0] });
        setOld(true);
      } else {
        setShow(true);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    getGoal();
    // Checking if the browser supports the necessary APIs
    if (
      navigator?.mediaDevices &&
      navigator?.mediaDevices?.getUserMedia &&
      !localStorage.getItem("cmAccess")
    ) {
      // Constraints for requesting camera and microphone
      const constraints = {
        audio: true, // Request microphone access
        video: true, // Request camera access
      };

      // Requesting camera and microphone permissions
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          // Permissions granted, you can now access camera and microphone
          // The stream object can be used to display video or capture audio
          // For example, to display video in an HTML element with id "videoElement":
          const videoTracks = stream.getVideoTracks();
          videoTracks.forEach(function (track) {
            track.stop();
          });
          const audioTracks = stream.getAudioTracks();
          audioTracks.forEach(function (track) {
            track.stop();
          });
          localStorage.setItem("cmAccess", true); // storing camera and mic access grant
        })
        .catch(function (error) {
          // An error occurred while requesting permissions
          console.error("Error accessing camera and microphone:", error);
        });
    } else {
      // Browser doesn't support getUserMedia API
      console.error("getUserMedia is not supported by this browser.");
    }
  }, []);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleCopy = (data) => {
    setCopied(copyToClipboard(data));
    setTimeout(() => {
      setCopied(null);
    }, 2000);
  };

  return (
    <Box>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1A1A1A",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            width: "400px",
            // height: "400px",
            position: "relative",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "#1A1A1A",
            padding: 0,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ border: "1px solid #1E1E1E", padding: "16px" }}
          >
            <Typography>{t("streamDetail.title")}</Typography>
            <CloseIcon
              className="_cp"
              onClick={() => handleClose(false)}
              color="default"
            />
          </Stack>
          <Stack
            direction="column"
            spacing={3}
            sx={{ padding: "16px", paddingBottom: "48px" }}
          >
            {isUserIdPresent ? (
              <RadioGroup
                sx={{ display: "flex", flexDirection: "row", color: "white" }}
                aria-labelledby="currency type"
                name="select token type"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="siki"
                  control={<Radio />}
                  label="SIKI"
                />
                <FormControlLabel value="obs" control={<Radio />} label="OBS" />
              </RadioGroup>
            ) : null}

            {value === "obs" ? (
              <Box
                sx={{
                  marginTop: "0px !important",
                }}
              >
                <Box>
                  <Typography
                    align="left"
                    // variant="h6"
                    style={{ color: "#ffffff", fontSize: "18px" }}
                  >
                    Server :
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px",
                      borderRadius: "4px",
                      border: "1px solid",
                      color: "#ffffff",
                    }}
                  >
                    <Typography sx={{ wordBreak: " break-all" }}>
                      {OBS_SERVER_URL}
                    </Typography>
                    <Tooltip leaveDelay={1000}>
                      <ContentCopyOutlinedIcon
                        className="_cp"
                        onClick={() => handleCopy(OBS_SERVER_URL)}
                        // sx={{ color: "#ffffff" }}
                      >
                        Outlined
                      </ContentCopyOutlinedIcon>
                    </Tooltip>
                  </Box>
                </Box>
                <Box
                  sx={{
                    marginTop: "10px !important",
                  }}
                >
                  <Typography
                    align="left"
                    // variant="h6"
                    style={{ color: "#ffffff", fontSize: "18px" }}
                  >
                    Stream key:
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px",
                      borderRadius: "4px",
                      border: "1px solid",
                      color: "#ffffff",
                    }}
                  >
                    <Typography sx={{ wordBreak: " break-all" }}>
                      {channelName}
                    </Typography>
                    <Tooltip leaveDelay={1000}>
                      <ContentCopyOutlinedIcon
                        className="_cp"
                        onClick={() => handleCopy(`${channelName}`)}
                      >
                        Outlined
                      </ContentCopyOutlinedIcon>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            ) : null}
            <Stack direction="column" spacing={1} sx={{ marginBottom: "24px" }}>
              <Typography className="fs-14">
                {t("streamDetail.label1")}
              </Typography>
              <OutlinedInput
                sx={{ height: "50px" }}
                type="text"
                placeholder={t("streamDetail.placeholder1")}
                value={title}
                onChange={(e) => (setTitle(e.target.value), setDirty(true))}
              />
            </Stack>
            <SikiInput
              label={t("streamDetail.label2")}
              placeholder={t("streamDetail.placeholder2")}
              multi={true}
              value={description}
              onChange={(e) => setDescription(e)}
              top="13px"
            />
            <Stack direction="column" spacing={1}>
              <Typography className="fs-14">
                {t("streamDetail.label3")}
              </Typography>
              <OutlinedInput
                sx={{ height: "50px" }}
                placeholder={t("streamDetail.placeholder3")}
                type="number"
                value={goal}
                onChange={(e) => (setGoal(e.target.value), setDirty(true))}
              />
            </Stack>
            {show}
            <Stack
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              {!show ? (
                <Button
                  sx={{
                    color: "#1E1E1E",
                    height: "30px !important",
                    fontWeight: "bold",
                    width: "85%",
                  }}
                  variant="contained"
                  color="primary"
                  disabled={!title || !goal}
                  // onClick={() => handleClose(true, title, goal, false)}
                  onClick={() => (setOld(true), setConfirm(true))}
                >
                  {t("streamDetail.button")}
                </Button>
              ) : null}
              <Button
                sx={{
                  color: "#1E1E1E",
                  height: "30px !important",
                  fontWeight: "bold",
                  width: "85%",
                }}
                variant="contained"
                color="primary"
                disabled={!title || !goal}
                // onClick={() => handleClose(true, title, goal, true)}
                onClick={() => (setOld(false), setConfirm(true))}
              >
                {t("streamDetail.button1")}
              </Button>

              <Typography
                color="primary"
                className="fs-14 __underline_hover _cp"
                onClick={() =>
                  handleClose(true, null, null, null, null, value === "obs")
                }
              >
                {t("streamDetail.button2")}
              </Typography>
              {/* <Typography
                color="primary"
                className="fs-14 __underline_hover _cp"
                // onClick={() => handleClose(true)}
                onClick={() => {
                  setOpenStream(true);
                  history.push(`/app/streams/1`);
                }}
              >
                Go live with obs
              </Typography> */}
            </Stack>
          </Stack>
        </DialogContent>
        {loading ? (
          <Loader
            wait={true}
            _class="__loader_inside"
            message={t("streamDetail.loader")}
          />
        ) : null}
        {confirm ? (
          <ConfirmPopup
            open={confirm}
            message={
              old
                ? `${dirty ? t("streamDetail.confirmText1") : ""} ${t(
                    "streamDetail.confirmText2"
                  )}`
                : t("streamDetail.confirmText3")
            }
            handleClose={(e) =>
              e
                ? (setConfirm(false),
                  handleClose(
                    true,
                    old && dirty ? oldGoal?.goalTitle : title,
                    old && dirty ? oldGoal?.totalGoalAmount : goal,
                    old && dirty ? oldGoal?.goalDescription : description,
                    old ? false : true,
                    value === "obs"
                  ))
                : setConfirm(false)
            }
          />
        ) : null}
        {openStream ? <StreamShow /> : null}
      </Dialog>
    </Box>
  );
}
